import { createAction } from "redux-actions";
import {
    TOGGLE_FINANCIAL_TARGET_GRID,
    UPDATE_DISPLAYED_ROWS,
    UPDATE_SELECTED_TARGET_IDS,
    UPDATE_COLLAPSE_MODE,
} from "./action-types";
import {
    UpdateDisplayedGridRowsPayload,
    UpdateSelectedTargetIdsPayload,
} from "reducers/collection-target/action-handlers";

export const toggleFinancialTargetGrid = createAction<void>(TOGGLE_FINANCIAL_TARGET_GRID);
export const updateSelectedTargetIds = createAction<UpdateSelectedTargetIdsPayload>(UPDATE_SELECTED_TARGET_IDS);
export const updateDisplayedRowsAction = createAction<UpdateDisplayedGridRowsPayload>(UPDATE_DISPLAYED_ROWS);
export const updateCollapseModeAction = createAction<boolean>(UPDATE_COLLAPSE_MODE);
